/**
 * Component to display the violation message of a window that violates division guideline
 * Two violation types: hard and soft. User will have to correct the hard violations in order 
 * to resubmit the window request edit/creation.
 * @description props.violation must exist, and be an violation instance returned from guideline 
 * validator service. Below is one example
 *      {
 *           "ruleId": 3,
 *           "message": "Between West Stockton to Fresno Startime should be >= 2230 if window is planned From Monday-Saturday",
 *           "warningType": "Soft"
 *      }
 */
import React from 'react';

import './ViolationCard.css';

const ViolationCard = (props) => {
    if (!props.violation) {
        console.error('props.violation is required');
        return;
    }

    const clsViolation = `cls${props.violation.warningType}Violation`;
    const clsViolationMessage = props.violation.warningType === 'Soft' ? 'text-warning' : props.violation.warningType === 'Success' ? 'text-success' : 'text-danger';

    return (
        <blockquote className = {'clsViolation ' + clsViolation}>
            <p className = {clsViolationMessage}>{props.violation.message}</p>
        </blockquote>
    );
}

export default ViolationCard;